import React, { useRef, useState, useEffect, Fragment } from 'react';
import {Link} from "react-router-dom"
import {Card} from "semantic-ui-react"
import {observer} from "mobx-react"
import ImageWithFallback from "components/ImageWithFallback"
import shop from "shop/shop"
import categoryStore from "stores/categoryStore"
import "./CategorySlider.scss"

const CategorySlider = observer(({ firstCategory, categoryforCardsLaboratory, categoryforCardsMedicine, className = "", orderMode}) => {

  const scrollRef = useRef(null);
  const scrollWrapperRef = useRef(null);
  const [scrollWidth, setScrollWidth] = useState(null);

  const scroll = (scrollOffset) => {
    scrollRef.current.scrollBy({ left: scrollOffset, behavior: 'smooth' });
  };

  useEffect(() => {
    const updateScrollWidth = () => {
      if (scrollWrapperRef.current) {
        const left = scrollWrapperRef.current.getBoundingClientRect().left;
        const vw = window.visualViewport ? window.visualViewport.width : window.innerWidth;
        setScrollWidth(`${vw - left}px`);
      }
    };

    requestAnimationFrame(updateScrollWidth);
    window.addEventListener('resize', updateScrollWidth);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateScrollWidth);
    }
    return () => {
      window.removeEventListener('resize', updateScrollWidth);
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', updateScrollWidth);
      }
    };
  }, []);

  let base = "";
  let parents = [];
  if (firstCategory && firstCategory.getParents) {
    parents = firstCategory.getParents();
    base = `/collection/${parents.map(id => `${id}/`).join("")}${firstCategory.map_id}/`;
  } else {
    base = `/collection/`;
  }

  return (
    <div className="relative w-100 CategorySlider" style={{ minHeight: "500px" }}>
      <div>
        <p className="f2 fw7 pb5 pt3 bt bw2 w-50">
          {firstCategory && firstCategory.map_id == 40
            ? translate("Produktkategorien Labor")
            : firstCategory && firstCategory.map_id == 49
            ? translate("Produktkategorien Medizin")
            : translate("Produktkategorien")}
        </p>
      </div>

      <div className="flex flex-row justify-start items-start" style={{ gap: "0.5rem" }}>
        <button className="CategorySlider__nav-btn" onClick={() => scroll(-300)}>
          <p>❮</p>
        </button>
        <button className="CategorySlider__nav-btn" onClick={() => scroll(300)}>
          <p>❯</p>
        </button>
      </div>

      <div
        ref={scrollWrapperRef}
        className="CategorySlider__scroll-wrapper"
        style={scrollWidth ? { width: scrollWidth } : {}}
      >
        <div ref={scrollRef} className="CategorySlider__scroll-container">
          {firstCategory && firstCategory.children && firstCategory.children.map(category => {
            if (shop.config.plugin && shop.config.plugin.SEOCategoryLink) {
              const seoCategory = categoryStore._SEOCategoryTree['/' + parents.map(id => `${id}/`).join("") + firstCategory.map_id + `/${category.map_id}`];
              base = `/collection/${seoCategory.textpath.substring(1)}`;
            } else {
              base = `/collection/${parents.map(id => `${id}/`).join("")}${category.map_id}/`;
            }
            return (
              <Fragment key={category.map_id}>
                <Card
                  style={{
                    borderRadius: "15px",
                    backgroundColor: "white",
                    backgroundSize: "cover",
                    overflow: "hidden",
                    backgroundPosition: "center",
                    minWidth: "300px",
                    maxWidth: "300px",
                    minHeight: "230px",
                    maxHeight: "420px",
                    boxShadow: "0 2px 4px 4px rgba(0, 0, 0, 0.1)",
                  }}
                  className={`CategoryCard ${className}`} as={Link} to={base}
                >
                  <ImageWithFallback
                    style={{ maxHeight: "200px", objectFit: "cover", objectPosition: "center" }}
                    src={category.img_src}
                    fallback={"/image/Rechteck 851.png"}
                  />
                  <div
                    className="white pa2 pa3-ns"
                    style={{
                      backgroundColor: "white",
                      overflow: "hidden",
                      display: "block",
                      objectFit: "cover",
                      objectPosition: "center",
                      minWidth: "500px",
                      minHeight: "230px",
                      maxHeight: "230px",
                    }}
                  >
                    <p className="black-30 pt3 f5 b pl3">{category.desc.short_des}</p>
                    <Link className="black db pa3 pl3 pt5 mt4 f3 b hover-primary underline-hover transition" to={base + "/"}>
                      {category.desc.short_des}
                    </Link>
                    <Link
                      className="db pl3 pr3 pb4 f5 b hover-primary color-primary underline-hover transition LinkBackgroundStyle"
                      to={base}
                    >
                      {translate("Produkte ansehen")}
                    </Link>
                  </div>
                </Card>
              </Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default CategorySlider;



// WEBPACK FOOTER //
// ./src/plugin/CategoryShortcuts/CategorySlider.js